var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"shrine-image",class:{'loading': _vm.loading}},[(_vm.map)?_c('a',{ref:"map-button",staticClass:"button button--map",attrs:{"href":""},on:{"click":function($event){$event.preventDefault();return _vm.showMap.apply(null, arguments)}}},[_vm._v(_vm._s((_vm.checkingMap) ? 'Put Away Map' : 'Check Map'))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }